import React from 'react';
import { Typography, Image, Spin } from 'antd';
import styled from '@emotion/styled';
import { EyeOutlined } from '@ant-design/icons';
import { toImageUrl } from '../../../../utils/azure';

interface IndexColumnProps {
  record: any;
}

export default React.memo((props: IndexColumnProps) => {
  const { record } = props;

  return (
    <StyledImageColumnContainer>
      {record && record?.link ? (
        <Image
          width={50}
          style={{ minHeight: 50 }}
          src={toImageUrl(record?.link)}
          preview={{ mask: <EyeOutlined /> }}
          placeholder={
            <Spin size="small" style={{ width: 50, minHeight: 50, paddingTop: 17, background: '#00000010' }} />
          }
        />
      ) : (
        <div className="image" />
      )}
      <Typography.Text style={{ marginLeft: '1rem' }}>{record.link}</Typography.Text>
    </StyledImageColumnContainer>
  );
});

const StyledImageColumnContainer = styled.div`
  display: flex;
  align-items: center;
  padding-left: 0.5rem;
  .image {
    width: 3.125rem;
    height: 3.125rem;
    background-color: #eee;
    background-size: cover;
    background-position: center center;
    border: 1px solid #eee;
    margin-right: 0.5rem;
  }
  span {
    font-weight: 600;
  }
  button {
    position: absolute;
    right: 0;
  }
  text-align: left !important;

  .ant-typography {
    width: 350px;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    line-height: 21px;
    max-height: 48px;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
  }
`;
